import { FaChrome, FaEdge, FaFirefox, FaSafari } from 'react-icons/fa';

export default function CompatibleBrowsers() {
  return (
    <div className='py-8 text-center dark:text-gray-300'>
      <h3>Alpaca Tracker utilizes advanced features </h3>
      <p>that are only supported in latest browsers</p>
      <div className='flex justify-center gap-4 pt-8 text-4xl '>
        <a
          href='https://support.apple.com/downloads/safari'
          className='hover:opacity-70 dark:hover:opacity-75'
        >
          <FaSafari title='Safari >= 11' />
        </a>
        <a
          href='https://www.mozilla.org/en-US/firefox/new/'
          className='hover:opacity-70 dark:hover:opacity-75'
        >
          <FaFirefox title='Firefox >= 59' />
        </a>
        <a
          href='https://www.microsoft.com/en-us/windows/microsoft-edge'
          className='hover:opacity-70 dark:hover:opacity-75'
        >
          <FaEdge title='Microsoft Edge >= 16' />
        </a>
        <a
          href='https://www.google.com/chrome/'
          className='hover:opacity-70 dark:hover:opacity-75'
        >
          <FaChrome title='Google Chrome >= 64' />
        </a>
      </div>
    </div>
  );
}
